import React from "react";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import {
  convertTo12HourFormatTimeRange,
  removeTrailZerosInTime,
} from "../../utils/utils";

type props = {
  slot: string;
};

export const SelectedSlot: React.FC<props> = ({ slot }) => {
  const timeFormat = slot.split(" ")[1];
  const timeSlot = convertTo12HourFormatTimeRange(slot.split(" ")[0]);

  return (
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <TCText
        style={{
          fontWeight: 500,
          fontSize: 12,
          color: Colors.green,
          marginTop: 2,
        }}
        value={`${removeTrailZerosInTime(timeSlot)}`}
      />
      <TCText
        style={{
          fontWeight: 500,
          fontSize: 8,
          color: Colors.green,
          marginTop: -2,
          marginLeft: 3,
        }}
        value={`${timeFormat}`}
      />
      <div
        style={{
          height: 14,
          width: 2,
          backgroundColor: Colors.lightGreyBackground,
          marginLeft: 10,
          marginRight: 10,
        }}
      />
    </div>
  );
};
